import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Icon } from '@wdx/shared/swagger-gen';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TranslateTokenisedStringPipe } from '@wdx/shared/utils';

export interface IconWithTextCellRendererParams {
    text?: string;
    icon?: Icon | string;
    iconScale?: number | null;
    iconToolTip?: string | null;
    clickCallback?: (data: any, params: ICellRendererParams) => void;
    classes?: string;
}

@Component({
    selector: 'wdx-ag-grid-icon-with-text-cell-renderer',
    imports: [
        WdxIconModule,
        NgClass,
        NgbTooltipModule,
        TranslateTokenisedStringPipe,
    ],
    templateUrl: './icon-with-text-cell-renderer.component.html',
    styleUrls: ['./icon-with-text-cell-renderer.component.scss'],
})
export class IconWithTextCellRendererComponent implements ICellRendererAngularComp {
    public classes = 'd-flex align-items-center w-100 text-truncate';
    public text?: string;
    public icon?: Icon;
    public iconToolTip?: string;
    public clickCallback?: (data: any, params: ICellRendererParams) => void;
    public iconScale = 1;
    private data: any;
    private params!: ICellRendererParams;

    public agInit(
        params: ICellRendererParams<any, IconWithTextCellRendererParams>,
    ): void {
        if (params?.value) {
            this.text = params.value.text;
            if (params.value.icon) {
                this.icon =
                    typeof params.value.icon === 'string'
                        ? { name: params.value.icon }
                        : params.value.icon;
            }
            this.clickCallback = params.value.clickCallback;
            this.params = params;
            this.data = params.data;
            if (params.value.classes) {
                this.classes = `${this.classes} ${params.value.classes}`;
            }
            if (params.value.iconScale) {
                this.iconScale = params.value.iconScale;
            }
            if (params.value.iconToolTip) {
                this.iconToolTip = params.value.iconToolTip;
            }
        }
    }

    public refresh(
        params: ICellRendererParams<any, IconWithTextCellRendererParams>,
    ): boolean {
        this.agInit(params);
        return true;
    }

    public onClick(event: MouseEvent) {
        if (!this.clickCallback) {
            return;
        }
        event.stopPropagation();
        this.clickCallback(this.data, this.params);
    }
}
